export const hingeOption = { id: 1, type: "squareHinges", label: "Emtek Square Barrel Hinges" }
export const concealedHingeOption = { id: 1, type: "squareHinges", label: "Black Concealed Hinges" }
